import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers() {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------

        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                let defaultNavigation: FuseNavigationItem[] = this._defaultNavigation;

                try {
                    const menu = localStorage.getItem('menu_items');
                    if (menu) {
                        defaultNavigation = JSON.parse(menu);
                    }
                } catch (e) {
                    console.error('NAVIGATION API : Menu format error, use default');
                    defaultNavigation = this._defaultNavigation;
                }

                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {
                    defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactNavItem.id) {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Clear Main Menus with no children
                let compactNavigation = this._compactNavigation.filter(e => [200,300,700].includes(e.id) === false || e.children.length > 0 );

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === futuristicNavItem.id) {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Clear Main Menus with no children
                let futuristicNavigation = this._futuristicNavigation.filter(e => [200,300,700].includes(e.id) === false || e.children.length > 0 );

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === horizontalNavItem.id) {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Clear Main Menus with no children
                let horizontalNavigation = this._horizontalNavigation.filter(e => [200,300,700].includes(e.id) === false || e.children.length > 0 );

                // Return the response
                return [
                    200,
                    {
                        compact: cloneDeep(compactNavigation),
                        default: cloneDeep(defaultNavigation),
                        futuristic: cloneDeep(futuristicNavigation),
                        horizontal: cloneDeep(horizontalNavigation)
                    }
                ];
            });
    }
}
